// extracted by mini-css-extract-plugin
export default {"root":"Stepper_root__J8Ej7","or-horizontal":"Stepper_or-horizontal__Yxcei","or-vertical":"Stepper_or-vertical__9cKXu"};